import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesLinkTypesDeactivateRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-linktypes-deactivate',
	path: '/secure/admin/IssueLinkingDeActivate.jspa',
};
